import request from '@/utils/requestYkp';
import { ApiPrefix } from '@/constants/constants';
export default {
	/** 查询数据概览列表 */
	querySjglList: (params?: object) => {
		return request({
			url: '/ykp/index/querySxed.do',
			method: 'get',
			params,
		});
	},
	/** 纳税人信息查询 */
	queryQyjbxx: (params?: object) => {
		return request({
			url: '/ykp/index/queryQyjbxx.do',
			method: 'get',
			params,
		});
	},
	/** 开票情况统计 */
	queryKpxxList: (data: object) => {
		return request({
			url: '/ykp/index/queryFptjsl.do',
			method: 'post',
			data,
		});
	},
	queryXxtbList: (params?: object) => {
		return request({
			url: '/ykp/index/infoSync.do',
			method: 'get',
			params,
		});
	},

	queryXxtbResult: (params?: object) => {
		return request({
			url: '/ykp/index/infoSyncResult.do',
			method: 'get',
			params,
		});
	},
	// 查询登录状态
	queryDlzt: () => {
		return request({
			url: '/ykp/fwtx/queryDlzt.do?qxxkdm=1',
			method: 'get',
		});
	},
	queryDzswjList: () => {
		return request({
			url: '/ykp/fwtx/queryDzswjList.do?jklx=6',
			method: 'get',
		});
	},
	// 查询消息列表
	selectMsgList: (params?: object) => {
		return request({
			url: ApiPrefix.YkpApiDefault + '/msg/selectMsgList',
			method: 'post',
			data: params,
		});
	},
	// 获取任务类型参数
	selectTaskTypeInfo: (params?: object) => {
		return request({
			url: ApiPrefix.YkpApiDefault + '/msg/selectTaskTypeInfo',
			method: 'post',
			data: params,
		});
	},
	// 标记已读
	updateReadStatus: (params?: object) => {
		return request({
			url: ApiPrefix.YkpApiDefault + '/msg/updateReadStatus',
			method: 'post',
			data: params,
		});
	},
	// 获取未读消息数量
	getUnReadCount: (params?: object) => {
		return request({
			url: ApiPrefix.YkpApiDefault + '/msg/selectUnReadCount',
			method: 'post',
			data: params,
		});
	},
	// 信息同步后给信息提示
	checkTicketinfoTip: (params?: object) => {
		return request({
			url: ApiPrefix.YkpApiDefault + '/index/checkTicketInfoTip.do',
			method: 'post',
			data: params,
		});
	},

	// 判断渠道是乐企还是RPA
	checkChannel: (params?: object) => {
		return request({
			url: ApiPrefix.GroupDefault + '/quickLogin/getDlpzType',
			method: 'get',
			params,
		});
	},
};

// 获取开票记录发票明细
export const orderDetailExclude = (params?: object) => {
	return request({
		url: ApiPrefix.YkpApiDefault + '/order/orderDetailExclude.do',
		method: 'get',
		params,
	});
};
// 获取发票发寻发票明细
export const fpxxMxExclude = (params?: object) => {
	return request({
		url: ApiPrefix.YkpApiDefault + '/stats/fpxxMxExclude.do',
		method: 'get',
		params,
	});
};
// 获取发票配置
export const getFpPz = (params?: object) => {
	return request({
		url: ApiPrefix.YkpApiDefault + '/plkp/queryOrderKzzdxx.do',
		method: 'post',
		data: params,
	});
};
// 删除发票
export const deleteInvoice = (params?: object) => {
	return request({
		url: ApiPrefix.YkpApiDefault + '/order/deleteInvoice.do',
		method: '',
		params,
	});
};
// 获取发票草稿明细
export const queryDraftInfo = (params?: object) => {
	return request({
		url: ApiPrefix.YkpApiDefault + '/elec/queryDraftInfo.do',
		method: 'get',
		params,
	});
};
